<template>
  <p text-block v-html="text" :out-only="outOnly" :in-only="inOnly"/>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'TextBlock',
  props: {
    file: { default: null },
    inOnly: { type:Boolean, default: false },
    outOnly: { type:Boolean, default: false },
    splitQ: { type:Boolean, default: false }
  },
  computed: {
    text() {
      let result = this.getText('sm');
      if (this.sect === 'sm') return result;
      if (this.info.md) result = this.getText('md');
      if (this.sect === 'md') return result;
      if (this.info.lg) result = this.getText('lg');
      if (this.sect === 'lg') return result;
      if (this.info.xl) result = this.getText('xl');
      if (this.sect === 'xl') return result;
      if (this.info.xxl) result = this.getText('xxl');
      if (this.sect === 'xxl') return result;
      return result;
    },
  },
  data() {
    return {
      info: {},
      output: {},
    };
  },
  methods: {
    getText(s) {
      if (!this.info[s]) return '';
      if (!this.output[s]) {
        if (!this.splitQ) {
          this.output[s] = _.trim(this.info[s]);
        } else {
          const l = _.trim(this.info[s]).split('\n');
          this.output[s] = _.map(l, line => `<q${this.outOnly ? ' out-only' : ''}${this.inOnly ? ' in-only' : ''}>${line}</q>`).join('\n');
        }
      }
      return this.output[s];
    },
  },
  mounted() {
    if (!this.file) return;
    this.info = require('../../views/page-text/'+this.lang+'/'+this.file).default;
  }
};
</script>

<style lang="less">
@import "~@/less/proj";
[text-block] {
}
</style>
